module.exports = __webpack_public_path__ + "img/epicenter_logo.6ee93933.png";